import React, {useEffect, useState} from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import userStore from './zustand/userStore'
import optionsStore from "./zustand/optionsStore";
import LogInView from "./views/LogInView/LogInView";
import HomeView from "./views/HomeView/HomeView";
import NoDesktop from "./views/NoDesktop/NoDesktop";
import { createTheme, ThemeProvider } from "@mui/material";
import AuthCompleted from "./views/LogInView/AuthCompleted/AuthCompleted";

const App = () => {
    const isLogged = userStore(state => state.isLogged)
    const isMobile = optionsStore(state => state.isMobile)
    const checkWindowSize = optionsStore(state => state.checkWindowSize)
    const checkLocation =optionsStore(state => state.checkLocation)
    const mainTheme = createTheme({
        palette: {
            primary: {
                main: '#2CC5E7'
            }
        }
    })
    const [isLoaded, setIsLoaded] = useState(false)

    useEffect(async () => {
        await checkWindowSize()
        await checkLocation()
        window.addEventListener('resize', checkWindowSize)
        setIsLoaded(true)
    }, [])
    return(
        <ThemeProvider theme={mainTheme}>
            <BrowserRouter>
                <div className="appWraper">
                    {isLoaded && <>{isMobile ? 
                    <>{isLogged ? 
                        <Routes>
                            <Route path="*" element={<Navigate to={`/home`} /> } />
                            <Route path="/home" element={<HomeView />} />
                        </Routes> :
                        <Routes>
                            <Route path="*" element={<Navigate to={`/logIn`} />} />
                            <Route path="/logIn" element={<LogInView />} />
                            <Route path="/authCompleted*" element={<AuthCompleted />} />
                        </Routes>
                    }</> :
                    <NoDesktop />
                }</>}
                </div>
            </BrowserRouter>
        </ThemeProvider>
    )
}

export default App